import {
  GET_ALL_REFERRAL_BEGIN,
  GET_ALL_REFERRAL_SUCCESS,
  GET_ALL_REFERRAL_ERROR,
  ADD_REFERRAL_BEGIN,
  ADD_REFERRAL_SUCCESS,
  ADD_REFERRAL_ERROR,
  GET_REFERRAL_BEGIN,
  GET_REFERRAL_SUCCESS,
  GET_REFERRAL_ERROR,
  UPDATE_REFERRAL_BEGIN,
  UPDATE_REFERRAL_SUCCESS,
  UPDATE_REFERRAL_ERROR,
  DELETE_REFERRAL_BEGIN,
  DELETE_REFERRAL_SUCCESS,
  DELETE_REFERRAL_ERROR,
} from "./constants";

const initState = {
  list: [],
  loading: false,
  error: null,
};

const ReferralReducer = (state = initState, action) => {
  const { type, data, error } = action;
  switch (type) {
    case ADD_REFERRAL_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_REFERRAL_SUCCESS:
      return {
        ...state,
        loading: false,
        list: [...state.list, data],
      };
    case ADD_REFERRAL_ERROR:
      return {
        ...state,
        error,
        loading: false,
      };
    case GET_ALL_REFERRAL_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_REFERRAL_SUCCESS:
      return {
        ...state,
        list: data,
        loading: false,
      };
    case GET_ALL_REFERRAL_ERROR:
      return {
        ...state,
        error,
        loading: false,
      };
    case GET_REFERRAL_BEGIN:
      return {
        ...state,
        loading: true,
        referralData: "",
      };
    case GET_REFERRAL_SUCCESS:
      return {
        ...state,
        loading: false,
        referralData: data,
      };
    case GET_REFERRAL_ERROR:
      return {
        ...state,
        error,
        loading: false,
      };
    case UPDATE_REFERRAL_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_REFERRAL_SUCCESS:
      return {
        ...state,
        loading: false,
        list: state.list.map((ele) => {
          if (ele.id === data.id) {
            return { ...data };
          } else return ele;
        }),
      };
    case UPDATE_REFERRAL_ERROR:
      return {
        ...state,
        error,
        loading: false,
      };
      case DELETE_REFERRAL_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_REFERRAL_SUCCESS:
      return {
        ...state,
        loading: false,
        list: state.list.filter((ele) => ele.id !== data.id),
      };
    case DELETE_REFERRAL_ERROR:
      return {
        ...state,
        error,
        loading: false,
      };
    default:
      return state;
  }
};

export default ReferralReducer;
